module.exports = __webpack_public_path__ + "static/media/step-1-id.337c104c.jpg";